import React, { useEffect, useRef } from "react";
import style from "./terms.module.css";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  const timerFadeIn = useRef(null);
  const termsRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (termsRef.current) {
      termsRef.current.classList.add(style.termsFadeIn);
    }

    timerFadeIn.current = setTimeout(() => {
      termsRef.current.classList.remove(style.termsFadeIn);
    }, 350);

    return () => {
      clearTimeout(timerFadeIn.current);
    };
  }, []);

  return (
    <div ref={termsRef} className={style.container}>
      <div className={style.iframeWrapper}>
        <iframe
          className={style.iframe}
          src="https://om.servicelands.com/trn/avocado/terms-en.html"
        ></iframe>
      </div>
    </div>
  );
};

export default Terms;
